import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Local components */
import { YouthComponent } from './youth.component';
import { YouthHomeComponent } from './components/home/youth-home.component';
import { YouthAttachedComponent } from './components/attached/youth-attached.component';
import { YouthRankingComponent } from './components/ranking/list/youth-ranking.component';
import { YouthRankingClassifComponent } from './components/ranking/classification/youth-ranking-classif.component';

/* Routes */
import { YouthRoutingModule } from './youth-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        YouthComponent,
        YouthHomeComponent,
        YouthAttachedComponent,
        YouthRankingComponent,
        YouthRankingClassifComponent,
    ],
    imports: [CommonModule, RouterModule, YouthRoutingModule, Interceptor, ThemeModule],
})
export class YouthModule {}
